import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound.vue';
import analysis from '../views/analysis.vue';
//import articles from '../views/articles.vue';
import faq from '../views/faq.vue';
import about from '../views/about.vue';
import accounttypes from '../views/accounttypes.vue';
import ecn from '../views/ecn.vue';
import moneyback from '../views/moneyback.vue';
import scalping from '../views/scalping.vue';
import partnership from '../views/partnership.vue';
import funding from '../views/funding.vue';
import products from '../views/products.vue';
import contact from '../views/contact.vue';
import glossary from '../views/glossary.vue';
import contract from '../views/contract.vue';
import account from '../views/account.vue';
import risk from '../views/risk.vue';
import orders from '../views/orders.vue';
import tradingconditions from '../views/tradingconditions.vue';
import privacy from '../views/privacy.vue';
import aml from '../views/aml.vue';
import disclaimer from '../views/disclaimer.vue';
import terms from '../views/terms.vue';
import agreement from '../views/agreement.vue';
import learningvideos from '../views/learningvideos.vue';
import courses from '../views/courses.vue'





Vue.use(VueRouter)

  const routes = [
  {
path: '/',
name: 'Home',
      meta: {
          title: 'Home Page - Example App',
      },
    component: Home
  },
 


      {
          path: '/:lang/faq',
          name: 'faq',
          meta: {
              title: ' Page - Example App',
          },
          component: faq
      },
       {
          path: '/:lang',
          name: 'Home',
          meta: {
              title: ' Page - Example App',
          },
          component: Home
      },
      
       {
          path: '/:lang/contract',
          name: 'contract',
          meta: {
              title: ' Page - Example App',
          },
          component: contract
      },
      {
          path: '/:lang/glossary',
          name: 'glossary',
          meta: {
              title: ' Page - Example App',
          },
          component: glossary
      },
       {
          path: '/:lang/about',
          name: 'about',
          meta: {
              title: ' Page - Example App',
          },
          component: about
      },
      {
          path: '/:lang/accounttypes',
          name: 'accounttypes',
          meta: {
              title: ' Page - Example App',
          },
          component: accounttypes
      },
      {
          path: '/:lang/ecn',
          name: 'ecn',
          meta: {
              title: ' Page - Example App',
          },
          component: ecn
      },
      {
          path: '/:lang/moneyback',
          name: 'moneyback',
          meta: {
              title: ' Page - Example App',
          },
          component: moneyback
      },
       {
          path: '/:lang/scalping',
          name: 'scalping',
          meta: {
              title: ' Page - Example App',
          },
          component: scalping
      },
      {
          path: '/:lang/partnership',
          name: 'partnership',
          meta: {
              title: ' Page - Example App',
          },
          component: partnership
      },
       {
          path: '/:lang/funding',
          name: 'funding',
          meta: {
              title: ' Page - Example App',
          },
          component: funding
      },
      {
          path: '/:lang/account',
          name: 'account',
          meta: {
              title: ' Page - Example App',
          },
          component: account
      },
      {
          path: '/:lang/products',
          name: 'products',
          meta: {
              title: ' Page - Example App',
          },
          component: products
      },
       {
          path: '/:lang/contact',
          name: 'contact',
          meta: {
              title: ' Page - Example App',
          },
          component: contact
      },
      {
          path: '/:lang/risk',
          name: 'risk',
          meta: {
              title: ' Page - Example App',
          },
          component: risk
      },
       {
          path: '/:lang/terms',
          name: 'terms',
          meta: {
              title: ' Page - Example App',
          },
          component: terms
      },
       {
          path: '/:lang/aml',
          name: 'aml',
          meta: {
              title: ' Page - Example App',
          },
          component: aml
      },
       {
          path: '/:lang/orders',
          name: 'orders',
          meta: {
              title: ' Page - Example App',
          },
          component: orders
      },
      {
          path: '/:lang/privacy',
          name: 'privacy',
          meta: {
              title: ' Page - Example App',
          },
          component: privacy
      },
       {
          path: '/:lang/tradingconditions',
          name: 'tradingconditions',
          meta: {
              title: ' Page - Example App',
          },
          component: tradingconditions
      },
      {
          path: '/:lang/disclaimer',
          name: 'disclaimer',
          meta: {
              title: ' Page - Example App',
          },
          component: disclaimer
      },
      {
          path: '/:lang/agreement',
          name: 'agreement',
          meta: {
              title: ' Page - Example App',
          },
          component: agreement
      },
       {
          path: '/:lang/learningvideos',
          name: 'learningvideos',
          meta: {
              title: ' Page - Example App',
          },
          component: learningvideos
      },
       {
          path: '/:lang/Technical%20Analysis',
          name: 'Analysis',
          meta: {
              title: ' Page - Example App',
          },
          component: analysis
      },
      {

          path: '/:lang/:name/:courseid',
          name: 'courses',
          meta: {
              title: ' courses',
          },
          component: courses
      },
      
    

      {
          path: '/:lang/:*',
          name: 'NotFound',
          component: NotFound
      },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
